import { path } from 'static-path';

export const root = () => '/';
export const login = () => '/login';
export const skills = () => '/sm/skills';
export const roster = () => '/sm/roster';
export const profile = path('/sm/roster/:slug');
export const bulkEditor = path('/sm/roster/:slug/bulk');
export const skillRoster = path('/sm/skills/:slug');
